import { render, staticRenderFns } from "./product-building-system.vue?vue&type=template&id=5d185398&scoped=true&"
import script from "./product-building-system.vue?vue&type=script&lang=js&"
export * from "./product-building-system.vue?vue&type=script&lang=js&"
import style0 from "./product-building-system.vue?vue&type=style&index=0&id=5d185398&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d185398",
  null
  
)

export default component.exports